import {
  SuperInputAutocomplete,
  SuperInputAutocompleteProps,
} from "@components:SuperInput/SuperInput.AutoComplete";
import {
  SuperInputNumberField,
  SuperInputNumberFieldProps,
} from "@components:SuperInput/SuperInput.NumberField";
import {
  SuperInputSelect,
  SuperInputSelectProps,
} from "@components:SuperInput/SuperInput.Select";
import {
  SuperInputSwitch,
  SuperInputSwitchProps,
} from "@components:SuperInput/SuperInput.Switch";
import {
  SuperInputTextField,
  SuperInputTextFieldProps,
} from "@components:SuperInput/SuperInput.TextField";
import { FC } from "react";

interface SuperInputComponent extends FC {
  TextField: FC<SuperInputTextFieldProps>;
  NumberField: FC<SuperInputNumberFieldProps>;
  Select: FC<SuperInputSelectProps>;
  Autocomplete: FC<SuperInputAutocompleteProps>;
  Switch: FC<SuperInputSwitchProps>;
}

export const SuperInput: SuperInputComponent = () => {
  return null;
};

SuperInput.TextField = SuperInputTextField;
SuperInput.NumberField = SuperInputNumberField;
SuperInput.Select = SuperInputSelect;
SuperInput.Autocomplete = SuperInputAutocomplete;
SuperInput.Switch = SuperInputSwitch;
